
import React, { Component, Fragment } from 'react'
import DropItemUI from '../../ddTxtImg/ui/DropItemUI'
import CenterElement from '../../activity/activityComponent/CenterElement'

class SortStoryDropItemUI extends DropItemUI {

    getFullDropItem = () => {
        //let { activity, quizViewer } = this.props
        // let { selectedStyle } = activity.dropItemContainer
        return (
            <div style={{ margin: "0px 10px", width: "150px", height: "210px", border: "solid 0px", position: "relative", display: "inline-block" }}
            //  style={(selectedStyle!=null)?selectedStyle[1].style:{}}
             >
                {
                    this.getDropItem()
                }
            </div>
        )
    }

    getDropItem = () => {
        let { dropItem, activity, quizViewer } = this.props

        let { quizViwerModel } = quizViewer.state
        let dropImg = quizViwerModel.imgRes + dropItem.dropImg
        let { selectedStyle } = activity.dropItemContainer

        return (
            <Fragment>
                <div
                //  style={(selectedStyle!=null)?selectedStyle[2].style:{}}
                 >
                    <table style={{ width: "100%", height: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                    <img style={{ width: "100%" }} src={dropImg} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div 
                //style={(selectedStyle!=null)?selectedStyle[3].style:{}}
                  style={{ width: "100%", height: "100%", overflow: "hidden", margin: "0 auto", display: "none" } } 

                >
                    <CenterElement
                        content={dropItem.qTxt}
                        style={{}}
                        textAlign="center" />
                </div>

                <div style={{position: "absolute", right: "-4px", top: "-4px", width: "40px", height: "40px", background: "white", border: "solid 1px grey", borderRadius: "4px" }}
                 //style={(selectedStyle!=null)?selectedStyle[4].style:{}}
                 >
                    <CenterElement
                        content={dropItem.dropTxt}
                        style={{ fontSize: "16px" }}
                        textAlign="center"
                        ref={(el) => this.itemToDrop = el} />
                </div>

            </Fragment>
        )
    }
}

export default SortStoryDropItemUI